import { render, staticRenderFns } from "./MasterObat.vue?vue&type=template&id=719d28c5"
import script from "./MasterObat.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterObat.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports